<!-- <bhub-board></bhub-board> -->
<bhub-top-bar class="fixed-top-bar" *ngIf="showTopBar"></bhub-top-bar>


<div>
  <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
  <router-outlet *ngIf="!isIframe">
    <!-- <bhub-board></bhub-board> -->
  </router-outlet>
</div>
